module.exports = __webpack_public_path__ + "static/media/Camera12.11b065cc.jpg";